<template>
  <div
    class="w-full h-full flex justify-center overflow-auto py-3 tablet-h:py-[14px]"
  >
    <div class="flex flex-col items-center mt-[90px]">
      <div
        class="flex items-center justify-center bg-gray-200/30 rounded-xl size-[126px] mb-[43px]"
      >
        <Lottie name="Infringement-Notice" class="min-w-[160px]" />
      </div>

      <div
        class="font-semibold font-primary text-[20px] leading-[20px] tracking-[-0.25px] text-gray-800 mb-4"
      >
        Create your first infringement report
      </div>

      <div
        class="font-secondary text-[14px] leading-[22px] text-gray-800 max-w-[340px] text-center mb-[26px]"
      >
        Upload a file to compare to one of your copyrights on Dacr for proof of
        infringement
      </div>

      <UiButton icon="Plus" primary @click="emit('create')">
        Infringement report
      </UiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import Lottie from '@/shared/components/Lottie.vue'
import { UiButton } from '@dacr/ui'

const emit = defineEmits(['create'])
</script>
